import { Product as e, ProductInfo as P, Environment as u } from "cerulean/dist/lib/product";
import { ONE_NAV_SUBDOMAIN_RE as A } from "../lib/location.js";
import { isInStorybook as N, isInOneNav as S } from "./is-in-onenav.js";
const C = (window == null ? void 0 : window.__ENVIRONMENT__) ?? "local", s = window == null ? void 0 : window.__CURRENTAPP__, d = s === e.ANALYTICS, I = s === e.AUDIENCES, _ = s === e.DATA, l = s === e.EXPERIMENT, w = s === e.EXPLORER, H = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.DATA, O = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.ANALYTICS, U = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.AUDIENCES, g = () => (window == null ? void 0 : window.__CURRENTAPP__) === e.EXPERIMENT, p = () => I ? e.AUDIENCES : _ ? e.DATA : l ? e.EXPERIMENT : e.ANALYTICS, T = {
  [e.ANALYTICS]: {
    fallbackHost: process.env.REACT_APP_ANALYTICS_HOST ?? "",
    isIn: d
  },
  [e.AUDIENCES]: {
    fallbackHost: process.env.REACT_APP_CEREBRO_HOST ?? "",
    isIn: I
  },
  [e.DATA]: {
    fallbackHost: process.env.REACT_APP_STARGATE_HOST ?? "",
    isIn: _
  },
  [e.EXPERIMENT]: {
    fallbackHost: process.env.REACT_APP_SKYLAB_HOST ?? "",
    isIn: l
  },
  [e.EXPLORER]: {
    fallbackHost: process.env.REACT_APP_EXPLORER_HOST ?? "",
    isIn: w
  }
}, a = (r) => r != null && r.length && r.charAt(0) !== "/" ? `/${r}` : r, L = (r) => r != null && r.length && r.charAt(r.length - 1) === "/" ? r.slice(0, -1) : r, R = (r) => {
  if (N())
    return "";
  if (!S()) {
    if (T[r].isIn)
      return "";
    const t = P[r].urls[C];
    return t || T[r].fallbackHost || P[r].urls[u.PRODUCTION];
  }
  return `/${r}`;
}, o = (r) => (t) => {
  const c = R(r);
  if (typeof t == "string") {
    const E = a(t) || "";
    return E.match(A) ? {
      pathname: E
    } : {
      pathname: c + E
    };
  }
  const n = a(t.pathname) || "";
  return n.match(A) ? {
    pathname: n
  } : {
    ...t,
    pathname: c + n
  };
}, i = (r) => (t) => {
  const c = R(r), n = a(t) || "";
  return n.match(A) ? n || "" : c + n;
}, X = o(
  e.ANALYTICS
), v = i(
  e.ANALYTICS
), y = o(
  e.AUDIENCES
), M = i(
  e.AUDIENCES
), Y = o(e.DATA), k = i(e.DATA), $ = o(
  e.EXPERIMENT
), b = i(
  e.EXPERIMENT
), B = o(
  e.EXPLORER
), W = i(
  e.EXPLORER
), V = (r) => typeof r == "object" && r.pathname ? `${r.pathname}${r.search ? `?${r.search}` : ""}` : r;
export {
  a as addLeadingSlash,
  V as coerceLocationToPathname,
  s as currentApp,
  p as getCurrentProduct,
  O as getIsInAnalytics,
  U as getIsInAudiences,
  H as getIsInData,
  g as getIsInExperiment,
  d as isInAnalytics,
  I as isInAudiences,
  _ as isInData,
  l as isInExperiment,
  w as isInExplorer,
  L as removeTrailingSlash,
  X as rewriteToAnalytics,
  v as rewriteToAnalyticsPath,
  y as rewriteToAudiences,
  M as rewriteToAudiencesPath,
  Y as rewriteToData,
  k as rewriteToDataPath,
  $ as rewriteToExperiment,
  b as rewriteToExperimentPath,
  B as rewriteToExplorer,
  W as rewriteToExplorerPath
};
//# sourceMappingURL=routing.js.map
